import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboard-chat-tabs d-flex flex-column" }

import { ref, onMounted, nextTick } from 'vue'
import MesageContainer from '../organisms/MesageContainer.vue'
import ThreadContainer from '../organisms/ThreadContainer.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardChatTabs',
  props: {
    targetableType: { default: 'School' },
    targetableId: {},
    threadId: { default: '' },
    hasSidebarBanner: { type: Boolean, default: false }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

const tab = ref<string>('chat')
const showCreateThreadBtn = ref(false)
const mesageContainer = ref<InstanceType<typeof MesageContainer> | null>(null)
const threadContainer = ref<InstanceType<typeof ThreadContainer> | null>(null)

onMounted(() => {
  tab.value = 'chat'
})

const toggleCreateThreadBtn = (show: boolean) => {
  showCreateThreadBtn.value = show
}

const scrollChatToBottom = () => {
  nextTick(() => {
    if (mesageContainer.value && (mesageContainer.value as any).scrollToBottom) {
      (mesageContainer.value as any).scrollToBottom()
    }
  })
}

const emitCreateThread = (_parentTab: number) => {
  if (mesageContainer.value && (mesageContainer.value as any).createThread) {
    (mesageContainer.value as any).createThread()
  }

  nextTick(() => {
    tab.value = 'chat'
  })

  showCreateThreadBtn.value = false
}

const updateParentTab = (tabIndex: number) => {
  tab.value = tabIndex === 1 ? 'chat' : 'thread'
}

const handleDashboardResize = () => {
  nextTick(() => {
    if (mesageContainer.value && (mesageContainer.value as any).autoExpandTextarea) {
      (mesageContainer.value as any).autoExpandTextarea()
    }
  })
}

__expose({
  handleDashboardResize
})

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_tabs, {
      modelValue: tab.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event)),
      class: "flex-shrink-0",
      style: {"max-height":"48px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tab, {
          value: "chat",
          onClick: scrollChatToBottom
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode("チャット", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_v_tab, { value: "thread" }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode("スレッド", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        }),
        _cache[6] || (_cache[6] = _createElementVNode("div", { style: {"padding-right":"40px"} }, null, -1 /* CACHED */)),
        (showCreateThreadBtn.value)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              class: "btn-new-chat",
              icon: true,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emitCreateThread(0)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("mdi-comment-plus", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]),
    _createVNode(_component_v_window, {
      modelValue: tab.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tab).value = $event)),
      class: "flex-grow-1"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, { value: "chat" }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(MesageContainer, {
              ref_key: "mesageContainer",
              ref: mesageContainer,
              key: `dashboard_${__props.targetableId}`,
              targetableId: __props.targetableId,
              targetableType: __props.targetableType,
              threadId: __props.threadId,
              toggleCreateThreadBtn: toggleCreateThreadBtn,
              showComponent: true,
              isDashboard: true,
              hasSidebarBanner: __props.hasSidebarBanner
            }, null, 8 /* PROPS */, ["targetableId", "targetableType", "threadId", "hasSidebarBanner"]))
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_v_window_item, { value: "thread" }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(ThreadContainer, {
              ref_key: "threadContainer",
              ref: threadContainer,
              key: `dashboard_thread_${__props.targetableId}`,
              targetableId: __props.targetableId,
              targetableType: __props.targetableType,
              parentTab: 1,
              onUpdateParentTab: updateParentTab,
              class: "h-100"
            }, null, 8 /* PROPS */, ["targetableId", "targetableType"]))
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ]))
}
}

})